/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import React, { useState, useEffect } from "react";

import GlobalSetting from "./GlobalSetting";
import { Box, CircularProgress } from "@mui/material";
import { refreshGlobalSettings } from "./globalSettingsFunctions";
import { Setting } from "../../../utils/Interfaces";
import StyledBreadcrumbs from "../../../components/general/StyledBreadcrumbs";
import { useAppDispatch } from "../../../app/hooks";
import { AnyAction, Dispatch } from "@reduxjs/toolkit";

const GlobalSettings = () => {
    const dispatch: Dispatch<AnyAction> = useAppDispatch();

    const [loading, setLoading] = useState<boolean>(false);
    const [globalSettings, setGlobalSettings] = useState<Setting[]>([]);

    useEffect(() => {
        refreshGlobalSettings(dispatch, setLoading, setGlobalSettings);
    }, []);

    return (
        <>
            <StyledBreadcrumbs
                paths={[
                    { text: "Techwise Portal", route: "/" },
                    { text: "Admin", route: "/?section=admin" },
                    { text: "Global Config", route: "/admin/config" },
                ]}
            />

            {loading && (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            marginTop: "20vh",
                        }}
                    >
                        <CircularProgress size={40} />
                    </Box>
                </Box>
            )}
            {!loading && (
                <>
                    {globalSettings.map((setting, index) => {
                        return (
                            <GlobalSetting
                                key={index}
                                setting={setting}
                                reloadSettings={() => refreshGlobalSettings(dispatch, setLoading, setGlobalSettings)}
                            />
                        );
                    })}
                </>
            )}
        </>
    );
};

export default GlobalSettings;
